import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContent } from '../../../content/ContentProvider';

export default function HeroSection() {
  const content = useContent();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };



  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-20 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={content.hero.backgroundImage}
          alt="Community"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 via-gray-900/60 to-gray-900/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-24">
        <div className="max-w-2xl space-y-6">
          <div className="inline-flex items-center gap-2 px-4.5 py-2 rounded-full bg-teal-500/10 border border-teal-500/25 text-teal-300 text-sm font-semibold mb-2 backdrop-blur-sm">
            <i className="ri-heart-fill text-teal-400"></i>
            <span>Bettako means &ldquo;For Everyone&rdquo;</span>
          </div>
          <h2
            className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {content.hero.headline}
          </h2>

          <p className="text-xl md:text-2xl text-gray-200 leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            {content.hero.subheadline}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 pt-2">
            <button
              onClick={() => scrollToSection(content.hero.ctaButtons[0].action)}
              className="px-8 py-4 bg-teal-500 hover:bg-teal-400 text-white font-semibold rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer text-lg"
            >
              <i className={`${content.hero.ctaButtons[0].icon} mr-2`}></i>
              {content.hero.ctaButtons[0].label}
            </button>
            <button
              onClick={() => scrollToSection(content.hero.ctaButtons[1].action)}
              className="px-8 py-4 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-semibold rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer text-lg backdrop-blur-sm"
            >
              <i className={`${content.hero.ctaButtons[1].icon} mr-2`}></i>
              {content.hero.ctaButtons[1].label}
            </button>
          </div>


        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <button onClick={() => scrollToSection('about')} className="text-white/60 hover:text-white transition-colors cursor-pointer w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-line text-2xl"></i>
        </button>
      </div>
    </section>
  );
}
